import { select } from '@ngrx/store';
import {
  ChangeDetectionStrategy,
  Component,
  Directive,
  HostBinding,
} from '@angular/core';

@Directive({
    selector: '[luiHeroBasicActionsStart]',
    standalone: false
})
export class HeroBasicActionsStartDirective {
  @HostBinding('class') hostClass = 'lui-hero-basic-actions-start';
}

@Directive({
    selector: '[luiHeroBasicActionsEnd]',
    standalone: false
})
export class HeroBasicActionsEndDirective {
  @HostBinding('class') hostClass = 'lui-hero-basic-actions-end';
}

@Component({
    selector: 'lui-hero-basic',
    template: `
    <div class="lui-hero-basic-container">
      <ng-content select="[luiHeroBasicActionsStart]"></ng-content>
      <div class="lui-hero-basic-main">
        <ng-content></ng-content>
      </div>
      <ng-content select="[luiHeroBasicActionsEnd]"></ng-content>
    </div>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeroBasicComponent {
  @HostBinding('class') hostClasses = ['lui-hero-basic', 'zone-dark'];
}
